<template>
</template>

<script>
import invoicesPrintHTML from '@/views/sales/invoices/SalesInvoicesPrintHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'SalesInvoicesPrint',
  mixins: [invoicesPrintHTML,printHtml],
  props: {
    invoice: {type:Object, required:false},
    invoices: {type:Array, required:false}
  },
  data() {
    return {
      company: null,
      province: null
    }
  },
  async created() {
    this.$emit('done');
    const results = await this.$apiCall(`query SalesInvoicesPrint {
                                            company {name,address,city,province,postalCode,email,businessNumber,phone,logoURL}
                                          }`,
                                        {});
    if (results.error)
      return;
    this.company = results.data.company;

    try {
      this.province = await import(`@/views/provinces/${this.$store.getters.company.province}/sales/invoicePrint.js`);
    // eslint-disable-next-line no-empty
    } catch (error) {}

    const lines = [];
    const logos = this.company.logoURL ? [] : null;
    const invoices = this.invoice ? [this.invoice] : this.invoices;
    let n = invoices.length - 1;
    for (const invoice of invoices) {
      lines.push(await this.printInvoice(invoice.id));
      if (n--)
        lines.push(`<div class="page-break"/>`);
      if (logos)
        logos.push({id:invoice.id, src:this.company.logoURL});
    }
    this.printHtml(`Invoice ${this.invoice?this.invoice.number:''}`, lines.join(''), logos);
  },
  methods: {
    async printInvoice(id) {
      const results = await this.$apiCall(`query SalesInvoicesPrint($id:ID!) {
                                              invoice(id:$id) {
                                                id,type,date,due,draft,voided,number,po,shipVia,shipToAddress,billToAddress,memo,taxInclusive,customerLicense,customerId
                                                salesRepName
                                                lines {
                                                  sku,description,taxCodeId,quantity,units,unitPrice,amount,precision,lot,type
                                                  items {sku,description,quantity,units,precision,lot}
                                                }
                                                taxLines {
                                                  id,name,amount,onAmount,percent
                                                }
                                                discount {percent,amount,value}
                                              }
                                            }`,
                                          {id});
      if (results.error)
        return;
      const invoice = results.data.invoice;
      return this.print(this.company, invoice, await this.province?.invoicePrint(invoice));
    }
  }
}
</script>